"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
const formatCurrency = (base, precision = 2, sign = false) => {
    let signDisplay = '';
    if (base > 0) {
        signDisplay = '+';
    }
    return ((sign ? signDisplay : '') +
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
        }).format(+base / 100));
};
exports.formatCurrency = formatCurrency;
